import { useNavigation } from '@react-navigation/native';
import { useAtomValue } from 'jotai';
import { Platform } from 'react-native';
import { isAnonymousUserAtom } from '@/atoms/Auth';
import { showLoginPrompt } from '@/utils/appInstallPrompt';
import { requestAppLogin } from '@/utils/appWebViewBridge';
export function useCheckAuth() {
    const navigation = useNavigation();
    const isAnonymousUser = useAtomValue(isAnonymousUserAtom);
    // 3번째 인자(message)는 네이티브 호환용 자리. 웹의 앱 전용(정보 등록·리뷰·신고 등)
    // 기능은 onAuth 안에서 이동 전에 앱 설치 팝업으로 막는다(useNavigateWithLocationCheck,
    // PDP 핸들러). RootScreen 라우트 게이트는 그걸 빠져나간 진입의 안전망이다.
    // 도움돼요/저장처럼 웹에서 가능한 액션은 그대로 실행한다.
    const checkAuth = (onAuth, onFailed, _message) => {
        var _a, _b;
        // 비회원이라면 로그인 페이지를 열고 (웹도 로그인 지원 → 웹/네이티브 공통)
        if (isAnonymousUser) {
            onFailed === null || onFailed === void 0 ? void 0 : onFailed();
            console.log('anonymous user! open login');
            // 앱 웹뷰 안이라면 로그인은 앱 LoginScreen 이 담당한다(웹뷰 안 애플 로그인은
            // 팝업 미지원으로 깨지고, 미가입 유저의 Signup 플로우도 웹에 없다).
            // false = 웹뷰가 아니거나 위임 미지원 구버전 앱 → 아래 기존 경로로 폴백.
            if (requestAppLogin()) {
                return;
            }
            // 웹: 카카오 로그인은 풀 페이지 리다이렉트라 모달 네비 스택이 소실된다.
            // 로그인 후 원래 페이지로 돌아오도록 현재 경로를 redirect 로 넘긴다.
            // 바로 /login 으로 넘어가면 어색해서, 앱 설치 유도와 동일 디자인의 로그인
            // 유도 팝업을 먼저 띄우고 OK 를 누를 때 이동한다.
            if (Platform.OS === 'web') {
                const loc = globalThis.location;
                const current = loc
                    ? ((_a = loc.pathname) !== null && _a !== void 0 ? _a : '') + ((_b = loc.search) !== null && _b !== void 0 ? _b : '')
                    : undefined;
                showLoginPrompt(() => {
                    navigation.navigate('Login', { asModal: true, redirect: current });
                });
                return;
            }
            navigation.navigate('Login', { asModal: true });
            return;
        }
        // 회원이라면 주어진 콜백을 실행
        onAuth();
    };
    return checkAuth;
}
